module.exports = __webpack_public_path__ + "static/Mobile Mockup-sm-2fe6ba436bac7e9d28c6742ea7d14aec.jpg";